module.exports={
  "Show more": "Vis mere"
}
